import productInformation from '#frontend/dtm/utils/productInformation.js';

import baseObject from './base.js';

/**
 * Build event object with requested product params
 * @param {object} cart
 * @param {Array} productParams
 * @returns {object}
 */
export default (cart, productParams = []) => ({
	...baseObject(cart),
	...productInformation(cart.order.products, productParams)
});
